import { Presenter, HeaderView, Model } from "./generic";
import { TextPresenter, TextHeaderView } from "./text";
import { DateTimePresenter } from "./date_time";
import { ActionPresenter } from "./action";
import { NumberPresenter } from "./number";
import { LinkPresenter } from "./link";
import { CheckboxPresenter, CheckboxHeaderView } from "./checkbox";
import { AmountPresenter } from "./amount";
import { RatePresenter } from "./rate";

export const generic = {
    Presenter,
    HeaderView,
    Model
};

export const text = {
    Presenter: TextPresenter,
    HeaderView: TextHeaderView,
    Model
};

export const date_time = {
    Presenter: DateTimePresenter,
    HeaderView,
    Model
};

export const action = {
    Presenter: ActionPresenter,
    HeaderView,
    Model
};

export const number = {
    Presenter: NumberPresenter,
    HeaderView,
    Model
};

export const link = {
    Presenter: LinkPresenter,
    HeaderView,
    Model
};

export const checkbox = {
    Presenter: CheckboxPresenter,
    HeaderView: CheckboxHeaderView,
    Model
};

export const amount = {
    Presenter: AmountPresenter,
    HeaderView,
    Model
};

export const rate = {
    Presenter: RatePresenter,
    HeaderView,
    Model
};
